import { createAction, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { logoutUser } from "./common";
import { RootState } from "../store/store";

export const resetStandingOrderSummary = createAction(
  "standingOrderSummary/reset"
);

type SliceState = {
  contentView: string;
  standingOrderDetail: any;
  standingOrderDailyAverage: any;
  existingCart: any[];
  status: string;
};

const initialState = {
  contentView: "",
  standingOrderDetail: null,
  standingOrderDailyAverage: null,
  existingCart: [],
  status: COMMON_STATUS.INITIAL,
} as SliceState;

export const standingOrderSummarySlice = createSlice({
  name: "standingOrderSummary",
  initialState,
  reducers: {
    setContentView: (state, action) => {
      state.contentView = action.payload;
    },
    setStandingOrderDetail: (state, action) => {
      state.standingOrderDetail = action.payload;
    },
    setSODailyAverage: (state, action) => {
      state.standingOrderDailyAverage = action.payload;
    },
    setSOExistingCart: (state, action) => {
      state.existingCart = [...action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetStandingOrderSummary, () => {
        return initialState;
      });
  },
});

export const {
  setContentView,
  setStandingOrderDetail,
  setSODailyAverage,
  setSOExistingCart,
} = standingOrderSummarySlice.actions;

export const getSOSContentView = (state: RootState) =>
  state.standingOrderSummary.contentView;

export const getSOSDetails = (state: RootState) =>
  state.standingOrderSummary.standingOrderDetail;

export const getSODailyAverage = (state: RootState) =>
  state.standingOrderSummary.standingOrderDailyAverage;

export const getSOExistingCart = (state: RootState) =>
  state.standingOrderSummary.existingCart;

export default standingOrderSummarySlice.reducer;
